var _circle, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolutionAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#96B1EC",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3663 38.0906C42.6213 38.0906 41.6345 38.0741 40.4059 38.0741C37.4096 38.0741 34.9459 35.5941 34.9459 32.5697V27.2633C34.9459 26.8458 34.6127 26.5059 34.1992 26.5059H25.4718C21.3988 26.5059 18.1068 29.8488 18.1068 33.9458V51.7245C18.1068 56.0228 21.5556 59.5059 25.8116 59.5059H38.8082C42.8664 59.5059 46.1568 56.1845 46.1568 52.0842V38.8331C46.1568 38.414 45.8251 38.0757 45.4102 38.0774C44.7125 38.0823 43.876 38.0906 43.3663 38.0906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.139 42.8387H36.1217C36.7998 42.8387 37.3509 43.3882 37.3509 44.0663C37.3509 44.7445 36.7998 45.2956 36.1217 45.2956H27.139C26.4609 45.2956 25.9114 44.7445 25.9114 44.0663C25.9114 43.3882 26.4609 42.8387 27.139 42.8387Z",
    fill: "#96B1EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0241 49.4292H27.1388C26.4607 49.4292 25.9112 49.9786 25.9112 50.6568C25.9112 51.3349 26.4607 51.886 27.1388 51.886H36.0241C36.7023 51.886 37.2534 51.3349 37.2534 50.6568C37.2534 49.9786 36.7023 49.4292 36.0241 49.4292Z",
    fill: "#96B1EC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.1426,
    y: 21.6422,
    width: 22,
    height: 17,
    rx: 4,
    fill: "#CAD7F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1385 27.6062L54.338 18.0558L37.3697 18.3295L37.1702 27.8799L54.1385 27.6062Z",
    fill: "#CAD7F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0288 28.9396L38.0289 28.9422C38.0344 29.2009 38.1435 29.4359 38.3174 29.6042C38.4908 29.7722 38.7299 29.8748 38.9904 29.8706L57.9288 29.565L57.9289 29.565C58.4511 29.5565 58.8682 29.1258 58.8598 28.6034L58.6969 18.503C58.6884 17.9807 58.2576 17.5636 57.7353 17.572L38.7969 17.8775C38.2746 17.8859 37.8575 18.3167 37.8659 18.839L38.0288 28.9396ZM39.9067 27.9627L39.7743 19.7547L56.8203 19.4797L56.9527 27.6877L39.9067 27.9627Z",
    fill: "#3665D3",
    stroke: "#3665D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7308 36.084L52.6683 25.3116L33.3699 23.3293L34.4325 34.1017L53.7308 36.084Z",
    fill: "#CAD7F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7431 34.2967L33.7432 34.2994C33.7487 34.558 33.8578 34.7931 34.0316 34.9614C34.2051 35.1293 34.4442 35.2319 34.7046 35.2277L53.6431 34.9222L53.6432 34.9222C54.1654 34.9136 54.5825 34.4829 54.5741 33.9606L54.4111 23.8601C54.4027 23.3378 53.9719 22.9207 53.4496 22.9291L34.5112 23.2347C33.9889 23.2431 33.5717 23.6739 33.5802 24.1962L33.7431 34.2967ZM35.621 33.3199L35.4886 25.1119L52.5345 24.8369L52.667 33.0449L35.621 33.3199Z",
    fill: "#3665D3",
    stroke: "#3665D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8063 27.3296C44.3472 27.3367 43.9881 27.616 43.7694 27.9803L43.7691 27.9807C43.5739 28.3067 43.4837 28.706 43.49 29.1013C43.4983 29.6354 43.6813 30.1505 44.0256 30.4839C44.2399 30.6913 44.528 30.8354 44.8624 30.8301C44.8625 30.8301 44.8626 30.8301 44.8627 30.8301L44.8569 30.4735L44.8572 30.4735C45.236 30.4674 45.4857 30.1851 45.6103 29.9664C45.7507 29.7199 45.8282 29.4052 45.8228 29.0646L44.8063 27.3296ZM43.8469 29.0958C43.8523 29.4365 43.9399 29.7487 44.0881 29.9906C44.1347 30.0666 44.1972 30.15 44.2754 30.2259C44.4178 30.3642 44.6122 30.4772 44.8566 30.4735L44.8568 30.4735L43.8469 29.0958Z",
    fill: "#3665D3",
    stroke: "#3665D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolutionAmount);
export default __webpack_public_path__ + "static/media/resolutionAmount.601bc8a1f8c26afe8d33f16d5401bf53.svg";
export { ForwardRef as ReactComponent };